import Layout from "./components/Layout/Default";
import { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import Provider from "components/Provider";
import "../src/i18n";

const PageNotFound = lazy(() => import("./components/PageNotFound"));
const LandingPage = lazy(() => import("./containers/LandingPage"));
const Checkout = lazy(() => import("./containers/Checkout"));
const PaymentResult = lazy(() => import("./containers/Result"));

function AppRouter() {
  const windowHeight = () => {
    const doc = document.documentElement;
    doc.style.setProperty("--window-height", `${window.innerHeight}px`);
  };

  useEffect(() => {
    window.addEventListener("resize", windowHeight);
    return () => window.removeEventListener("resize", windowHeight);
  });

  useEffect(() => {
    windowHeight();
  }, []);

  return (
    <BrowserRouter>
      <Provider>
        <AnimatePresence mode="wait" initial={false}>
          <Layout>
            <Suspense fallback={<></>}>
              <Routes key={"1"}>
                <Route path="/" Component={LandingPage} />
                <Route path="/checkout" Component={Checkout} />
                <Route path="/order-result" Component={PaymentResult} />
                <Route path="*" Component={PageNotFound} />
              </Routes>
            </Suspense>
          </Layout>
        </AnimatePresence>
      </Provider>
    </BrowserRouter>
  );
}
export default AppRouter;
